// components
import { styled, Paper, PaperProps, alpha } from '@mui/material';
import { GridCompact12To4ExtraLarge } from 'components/shared/Grid/Grid.components';

export const StyledAddWidgetDialogPaper = styled(Paper)<PaperProps>(() => ({
  width: '440px'
}));

export const CustomGridCompact12To4ExtraLarge = styled(
  GridCompact12To4ExtraLarge
)(({ theme }) => ({
  boxSizing: 'border-box',
  border: `1px dashed ${theme.vars.palette.secondary.fixedDim}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(4),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(4),
  cursor: 'pointer',
  color: alpha(theme.palette.secondary.main, 0.6),
  transition: 'background-color .2s ease',
  height: '220px',

  '&:hover': {
    backgroundColor: theme.vars.palette.surface.dim
  },

  '&:active': {
    backgroundColor: theme.vars.palette.surface.containerHighest
  }
}));
